import AppPageSwitcher from './AppPageSwitcher';

export default AppPageSwitcher;